import { fixBody } from "@/helpers/variables";
import type {ActionContext} from "vuex";
import type {RootState} from "@/store";
import {$http} from "@/utils/https";

interface State {
    pushesData: any;
    showPushes: boolean;
}

const state: State = {
    pushesData: null,
    showPushes: false
};

const getters = {
    pushesData: (state: State) => state.pushesData,
    showPushes: (state: State) => state.showPushes,
};

const actions = {
    FETCH_PUSHES_DATA: async ({commit}: ActionContext<State, RootState>) => {
        try {
            const response = await $http.get('v1/pushes');
            commit('SET_PUSHES_DATA', response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        }
    }
}

const mutations = {
    SET_PUSHES_DATA: (state: State, payload: any) => {
        state.pushesData = payload;
    },
    CHANGE_PUSHES_STATUS: (state: State, payload: any) => {
        state.showPushes = payload;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
